


import React, { useState, useEffect } from "react";
import {
    Box, Card, CardContent, Typography, Grid, TextField,
    MenuItem, Button, Chip, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Paper, Checkbox,
    Select, InputAdornment, InputLabel, FormControl, Divider
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import {
    getVendorMenuItemsAPI,
} from "../../../../Component/Servicefile/campaignService";

const GoalDetails = ({ formData, goals, subGoals, onInputChange, onNext, handleGoalConfigChange, setMenuItems, menuItems, groupedItems, setGroupedItems }) => {

    const [discountTarget, setDiscountTarget] = useState("overall");
    const [overallDiscount, setOverallDiscount] = useState({ type: "percentage", value: "" });
    const [categoryFilter, setCategoryFilter] = useState("All");
    const [searchTerm, setSearchTerm] = useState("");

    // ✅ Replace static useState with empty array
    // const [menuItems, setMenuItems] = useState([]);
    // ✅ State additions needed at top
    const [expandedCategories, setExpandedCategories] = useState({});

    const toggleCategory = (categoryName) => {
        setExpandedCategories(prev => ({
            ...prev,
            [categoryName]: !prev[categoryName]
        }));
    };

    // ✅ Group menuItems by category
    useEffect(() => {
        const grouped = menuItems.reduce((acc, item) => {
            if (!acc[item.category]) acc[item.category] = [];

            acc[item.category].push({
                ...item,
                selected: item.selected || false,
                discountValue: item.discountValue || ""
            });

            return acc;
        }, {});

        setGroupedItems(grouped); // ✅ SEND TO PARENT
    }, [menuItems]);
    // ✅ Add this useEffect to fetch and format real menu data
    useEffect(() => {
        const fetchMenuItems = async () => {
            try {
                const formattedMenuItems =
                    await getVendorMenuItemsAPI();

                setMenuItems(
                    formattedMenuItems
                );

            } catch (error) {
                console.error(
                    "❌ Error fetching menu items:",
                    error
                );
            }
        };

        fetchMenuItems();
    }, []);

    const categories = ["All", ...new Set(menuItems.map(i => i.category))];
    const selectedItems = menuItems.filter(i => i.selected);

    const filteredItems = menuItems.filter(item => {
        const matchCategory = categoryFilter === "All" || item.category === categoryFilter;
        const matchSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
        return matchCategory && matchSearch;
    });


    useEffect(() => {
        const selectedItems = menuItems.filter(i => i.selected);

        onInputChange("goalConfig", {
            ...(formData.goalConfig || {}),
            discount: {
                ...(formData.goalConfig?.discount || {}),
                selectedItems: selectedItems
            }
        });


    }, [menuItems]);

    const toggleSelectItem = (id) => {
        setMenuItems(prev => prev.map(item => item.id === id ? { ...item, selected: !item.selected } : item));
    };

    const toggleSelectAll = () => {
        const allSelected = filteredItems.every(i => i.selected);
        const ids = filteredItems.map(i => i.id);
        setMenuItems(prev => prev.map(item => ids.includes(item.id) ? { ...item, selected: !allSelected } : item));
    };

    const updateItemDiscount = (id, field, value) => {
        setMenuItems(prev => prev.map(item => item.id === id ? { ...item, [field]: value } : item));
    };

    const discountedPrice = (item) => {
        if (!item.discountValue) return item.price;
        if (item.discountType === "percentage")
            return (item.price - (item.price * item.discountValue) / 100).toFixed(2);
        return Math.max(0, item.price - parseFloat(item.discountValue)).toFixed(2);
    };

    const getOverallFinalPrice = (price) => {
        if (!overallDiscount.value) return price;
        if (overallDiscount.type === "percentage")
            return (price - (price * overallDiscount.value) / 100).toFixed(2);
        return Math.max(0, price - parseFloat(overallDiscount.value)).toFixed(2);
    };

    return (
        <Box sx={{ mx: "auto", px: { xs: 2, md: 3 }, py: 1, marginLeft: "-20px", marginTop: "-5px" }}>
            <Card elevation={3} sx={{ borderRadius: "16px", overflow: "hidden", }}>
                <CardContent sx={{ p: { xs: 3, md: 4, } }}>

                    {/* Header */}

                    {/* Form Grid */}
                    <Grid container spacing={2} >
                        {/* Campaign Name */}


                        {/* Goal */}
                        <Grid item xs={12} md={3} sx={{
                            "@media (min-width:1200px) and (max-width:1300px)": {
                                flexBasis: "33.33%",   // increase width
                                maxWidth: "33.33%",
                            }
                        }}>
                            <Typography sx={{ mb: 1, fontWeight: 600, fontSize: "13px", color: "#374151", width: "70%" }}>
                                Goal <span style={{ color: "#ef4444" }}>*</span>
                            </Typography>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                value={formData.goal}
                                onChange={(e) => {
                                    onInputChange("goal", e.target.value);
                                    onInputChange("subGoal", "");
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "10px",
                                        backgroundColor: "#f8fafc",
                                        fontSize: "13px",
                                        "&:hover fieldset": { borderColor: "#3b82f6" },
                                        "&.Mui-focused fieldset": { borderColor: "#3b82f6" }
                                    },
                                    "& .MuiSelect-select": { fontSize: "13px" }
                                }}
                            >
                                <MenuItem value="" disabled sx={{ fontSize: "13px", color: "#9ca3af" }}>
                                    Select goal
                                </MenuItem>
                                {goals.map((goal) => (
                                    <MenuItem key={goal.value} value={goal.value} sx={{ fontSize: "13px" }}>
                                        {goal.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        {formData.goal !== "discount" && (
                            <Grid item xs={12} md={3} sx={{
                                "@media (min-width:1200px) and (max-width:1300px)": {
                                    flexBasis: "33.33%",   // increase width
                                    maxWidth: "33.33%",
                                }
                            }}>
                                <Typography sx={{ mb: 1, fontWeight: 600, fontSize: "13px", color: "#374151" }}>
                                    Campaign Name <span style={{ color: "#ef4444" }}>*</span>
                                </Typography>

                                <TextField
                                    fullWidth
                                    placeholder="Enter campaign name"
                                    value={formData.campaignName || ""}
                                    onChange={(e) => onInputChange("campaignName", e.target.value)}
                                    size="small"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "10px",
                                            backgroundColor: "#f8fafc",
                                            fontSize: "13px",
                                            "&:hover fieldset": { borderColor: "#3b82f6" },
                                            "&.Mui-focused fieldset": { borderColor: "#3b82f6" }
                                        },
                                        "& input::placeholder": {
                                            fontSize: "13px",
                                            color: "#9ca3af"
                                        }
                                    }}
                                />
                            </Grid>
                        )}
                        {/* Sub Goal — hidden when discount */}
                        {/* Sub Goal — card picker for leads, dropdown for others */}
                        {formData.goal !== "discount" && (
                            <Grid item xs={12} md={formData.goal === "leads" ? 12 : 3} >
                                <Typography sx={{ mb: 1, fontWeight: 600, fontSize: "13px", color: "#374151" }}>
                                    Sub Goal <span style={{ color: "#ef4444" }}>*</span>
                                </Typography>

                                {formData.goal === "leads" ? (
                                    /* ── Facebook-style card picker ── */
                                    <Box
                                        sx={{
                                            display: "grid",
                                            gridTemplateColumns: {
                                                xs: "1fr",            // 📱 mobile → 1 card
                                                sm: "1fr",            // small → 1 card
                                                md: "repeat(2, 1fr)", // tablet → 2 cards (optional)
                                                lg: "repeat(3, 1fr)", // 💻 large → 3 cards
                                            },
                                            gap: "10px"
                                        }}
                                    >
                                        {subGoals.leads.map((sg) => {
                                            const isSelected = formData.subGoal === sg.value;
                                            return (
                                                <Box
                                                    key={sg.value}
                                                    onClick={() => onInputChange("subGoal", sg.value)}
                                                    sx={{
                                                        cursor: "pointer",
                                                        border: isSelected ? "2px solid #3b82f6" : "1.5px solid #e5e7eb",
                                                        borderRadius: "12px",
                                                        padding: "14px 12px",
                                                        backgroundColor: isSelected ? "#eff6ff" : "#f8fafc",
                                                        transition: "border-color 0.15s, background-color 0.15s",
                                                        "&:hover": {
                                                            borderColor: "#3b82f6",
                                                            backgroundColor: "#eff6ff",
                                                        },
                                                    }}
                                                >
                                                    <Box sx={{ mb: 1 }}>{sg.icon}</Box>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#111827", mb: 0.5 }}>
                                                        {sg.label}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: "11px", color: "#6b7280", lineHeight: 1.4 }}>
                                                        {sg.description}
                                                    </Typography>
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                ) : (
                                    /* ── Regular dropdown for all other goals ── */
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        value={formData.subGoal}
                                        disabled={!formData.goal}
                                        onChange={(e) => onInputChange("subGoal", e.target.value)}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "10px",
                                                backgroundColor: formData.goal ? "#f8fafc" : "#f1f5f9",
                                                fontSize: "13px",
                                                "&:hover fieldset": { borderColor: formData.goal ? "#3b82f6" : "#e5e7eb" },
                                                "&.Mui-focused fieldset": { borderColor: "#3b82f6" },
                                            },
                                            "& .MuiSelect-select": { fontSize: "13px" },
                                        }}
                                    >
                                        <MenuItem value="" disabled sx={{ fontSize: "13px", color: "#9ca3af" }}>
                                            {formData.goal ? "Select sub goal" : "Select goal first"}
                                        </MenuItem>
                                        {formData.goal && subGoals[formData.goal]?.map((subGoal) => (
                                            <MenuItem key={subGoal.value} value={subGoal.value} sx={{ fontSize: "13px" }}>
                                                {subGoal.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            </Grid>
                        )}
                        {formData.goal === "discount" && (
                            <Grid item xs={12} md={3} sx={{
                                "@media (min-width:1200px) and (max-width:1300px)": {
                                    flexBasis: "33.33%",   // increase width
                                    maxWidth: "33.33%",
                                }
                            }}>
                                <Typography sx={{ mb: 1, fontWeight: 600, fontSize: "13px", color: "#374151" }}>
                                    Sub Goal<span style={{ color: "#ef4444" }}>*</span>
                                </Typography>

                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    value={formData.subGoal}
                                    onChange={(e) => onInputChange("subGoal", e.target.value)}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "12px",
                                            backgroundColor: "#f8fafc",
                                            // padding: "10px 12px",
                                            // minHeight: "48px",

                                            display: "flex",
                                            alignItems: "center",

                                            transition: "all 0.2s ease",

                                            "& fieldset": {
                                                borderColor: "#e5e7eb",
                                            },

                                            "&:hover fieldset": {
                                                borderColor: "#3b82f6",
                                            },

                                            "&.Mui-focused fieldset": {
                                                borderColor: "#3b82f6",
                                                borderWidth: "2px",
                                            },
                                        },

                                        "& .MuiSelect-select": {
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "6px 4px !important",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                        },
                                    }}
                                >
                                    <MenuItem value="" disabled>Select type</MenuItem>
                                    {/* <MenuItem value="menu">Menu</MenuItem> */}
                                    {/* <MenuItem value="advertisement">Adds</MenuItem> */}
                                    <MenuItem value="coupons">Coupons</MenuItem>
                                </TextField>
                            </Grid>
                        )}

                    </Grid>

                    {/* ✅ DISCOUNT SECTION */}
                    {formData.goal === "discount" && formData.subGoal === "menu" && (
                        <Box sx={{ mt: 4 }}>
                            <Divider sx={{ mb: 3 }} />

                            {/* ✅ ALL CONTROLS IN ONE ROW */}
                            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", alignItems: "center", mb: 3 }}>


                                {["overall", "specific"].map((type) => (
                                    <Chip
                                        key={type}
                                        label={type === "overall" ? "🍽️ Overall Menu" : "🎯 Specific Items"}
                                        onClick={() => {
                                            setDiscountTarget(type);

                                            // ✅ PASS TO PARENT
                                            onInputChange("goalConfig", {
                                                ...(formData.goalConfig || {}),
                                                discount: {
                                                    ...(formData.goalConfig?.discount || {}),
                                                    discountType: type   // 👈 THIS IS IMPORTANT
                                                }
                                            });
                                        }}
                                        variant={discountTarget === type ? "filled" : "outlined"}
                                        color={discountTarget === type ? "primary" : "default"}
                                        sx={{ fontWeight: 600, fontSize: "13px", px: 1, cursor: "pointer", height: 36 }}
                                    />
                                ))}

                                {/* Divider line between toggle and controls */}
                                <Divider orientation="vertical" flexItem />





                                {discountTarget === "overall" &&
                                    formData?.goalConfig?.discount?.discountType !== "bogo" && (
                                        <TextField
                                            size="small"
                                            type="number"
                                            placeholder={
                                                formData?.goalConfig?.discount?.discountType === "percentage"
                                                    ? "Enter %"
                                                    : "Enter %"
                                            }
                                            value={formData?.goalConfig?.discount?.discountValue || ""}
                                            onChange={(e) =>
                                                handleGoalConfigChange(
                                                    "discount",
                                                    "discountValue",
                                                    Math.max(0, e.target.value)
                                                )
                                            }
                                            sx={{
                                                width: 150,
                                                height: 35,
                                                "& .MuiOutlinedInput-root": {
                                                    borderRadius: "10px",
                                                    backgroundColor: "#fff7ed",
                                                    fontWeight: 600,
                                                    "&:hover fieldset": { borderColor: "#f97316" },
                                                    "&.Mui-focused fieldset": { borderColor: "#ea580c" }
                                                },
                                                "& input": {
                                                    fontWeight: 700,
                                                    fontSize: "15px",
                                                    color: "#c2410c"
                                                }
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 700,
                                                                fontSize: "14px",
                                                                color: "#ea580c",
                                                                backgroundColor: "#ffedd5",
                                                                px: 1,
                                                                py: 0.3,
                                                                borderRadius: "6px"
                                                            }}
                                                        >
                                                            {formData?.goalConfig?.discount?.discountType === "percentage"
                                                                ? "%"
                                                                : "%"}
                                                        </Typography>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    )}



                                {discountTarget === "specific" && (
                                    <TextField
                                        size="small"
                                        placeholder="Search items..."
                                        value={searchTerm}
                                        onChange={e => setSearchTerm(e.target.value)}
                                        sx={{ width: 200, }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                )}

                                {/* Category filter chips — only for specific */}
                                {discountTarget === "specific" && (
                                    <FormControl size="small" sx={{
                                        minWidth: 160,
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "10px",
                                            backgroundColor: "#f8fafc",
                                            "&:hover fieldset": { borderColor: "#3b82f6" },
                                            "&.Mui-focused fieldset": { borderColor: "#3b82f6" }
                                        }
                                    }}>
                                        <Select
                                            value={categoryFilter}
                                            displayEmpty
                                            onChange={e => setCategoryFilter(e.target.value)}
                                            renderValue={(selected) => (
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    <span>🗂️</span>
                                                    <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                                                        {selected === "All" ? "All Categories" : selected}
                                                    </Typography>
                                                </Box>
                                            )}
                                        >
                                            {categories.map(cat => (
                                                <MenuItem key={cat} value={cat} sx={{ fontSize: "13px" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                                        <Typography sx={{ fontSize: "13px" }}>
                                                            {cat === "All" ? "🗂️ All Categories" : cat}
                                                        </Typography>
                                                        {categoryFilter === cat && (
                                                            <Chip label="✓" size="small" color="primary" sx={{ height: "18px", fontSize: "11px" }} />
                                                        )}
                                                    </Box>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}

                                {/* Live summary chip — overall only */}
                                {discountTarget === "overall" && (overallDiscount.value || overallDiscount.type === "bogo") && (
                                    <Chip
                                        label={
                                            overallDiscount.type === "bogo"
                                                ? "Buy 1 Get 1 Free on all items"
                                                : overallDiscount.type === "percentage"
                                                    ? `${overallDiscount.value}% off on all items`
                                                    : `₹${overallDiscount.value} off on all items`
                                        }
                                        color="success"
                                        size="small"
                                        sx={{ fontWeight: 600, height: 36 }}
                                    />
                                )}

                            </Box>

                            {/* Overall Preview Table */}
                            {discountTarget === "overall" && (
                                <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: "10px" }}>
                                    <Table size="small">
                                        <TableHead sx={{ backgroundColor: "#f97316" }}>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff", width: 40 }} />
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Item / Category</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Original Price</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Discounted Price</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Object.entries(groupedItems).map(([categoryName, items]) => (
                                                <React.Fragment key={categoryName}>

                                                    {/* ✅ Category Row */}
                                                    <TableRow
                                                        onClick={() => toggleCategory(categoryName)}
                                                        sx={{
                                                            backgroundColor: "#fff7ed",
                                                            cursor: "pointer",
                                                            "&:hover": { backgroundColor: "#ffedd5" }
                                                        }}
                                                    >
                                                        <TableCell>
                                                            <IconButton size="small">
                                                                {expandedCategories[categoryName]
                                                                    ? <KeyboardArrowUp fontSize="small" />
                                                                    : <KeyboardArrowDown fontSize="small" />}
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell colSpan={4}>
                                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                <Typography sx={{ fontWeight: 700, fontSize: "13px", color: "#c2410c" }}>
                                                                    🍽️ {categoryName}
                                                                </Typography>
                                                                <Chip
                                                                    label={`${items.length} items`}
                                                                    size="small"
                                                                    sx={{ fontSize: "11px", backgroundColor: "#fed7aa", color: "#c2410c", fontWeight: 600 }}
                                                                />
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>

                                                    {/* ✅ Subcategory / Dish Rows */}
                                                    {expandedCategories[categoryName] && items.map(item => (
                                                        <TableRow
                                                            key={item.id}
                                                            hover
                                                            sx={{ backgroundColor: "#fffbf7" }}
                                                        >
                                                            <TableCell />

                                                            <TableCell>
                                                                <Typography sx={{ fontSize: "13px", fontWeight: 500, pl: 1 }}>
                                                                    {item.name}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>₹{item.price}</TableCell>
                                                            <TableCell sx={{ fontWeight: 600, color: "#059669" }}>
                                                                {overallDiscount.type === "bogo"
                                                                    ? "Buy 1 Get 1"
                                                                    : overallDiscount.value
                                                                        ? `₹${getOverallFinalPrice(item.price)}`
                                                                        : `₹${item.price}`}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}

                                                </React.Fragment>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}

                            {/* Specific Items Table */}
                            {discountTarget === "specific" && (
                                <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: "10px" }}>
                                    <Table size="small">
                                        <TableHead sx={{ backgroundColor: "#f97316" }}>
                                            <TableRow>
                                                <TableCell padding="checkbox" />
                                                <TableCell sx={{ fontWeight: 700, color: "#fff", width: 40 }} />
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Item</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Price</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Discount Type</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Value</TableCell>
                                                <TableCell sx={{ fontWeight: 700, color: "#fff" }}>Final Price</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Object.entries(groupedItems)
                                                // ✅ Apply category filter
                                                .filter(([categoryName]) =>
                                                    categoryFilter === "All" || categoryFilter === categoryName
                                                )
                                                .map(([categoryName, items]) => {

                                                    // ✅ Apply search filter within category
                                                    const visibleItems = items.filter(item =>
                                                        item.name.toLowerCase().includes(searchTerm.toLowerCase())
                                                    );

                                                    if (visibleItems.length === 0) return null;

                                                    const allSelected = visibleItems.every(i => i.selected);
                                                    const someSelected = visibleItems.some(i => i.selected);

                                                    return (
                                                        <React.Fragment key={categoryName}>

                                                            {/* ✅ Category Row */}
                                                            <TableRow
                                                                sx={{
                                                                    backgroundColor: "#fff7ed",
                                                                    cursor: "pointer",
                                                                    "&:hover": { backgroundColor: "#ffedd5" }
                                                                }}
                                                            >
                                                                {/* Select all in this category */}
                                                                <TableCell padding="checkbox">
                                                                    <Checkbox
                                                                        size="small"
                                                                        checked={allSelected}
                                                                        indeterminate={someSelected && !allSelected}
                                                                        onChange={() => {
                                                                            const shouldSelect = !allSelected;
                                                                            setMenuItems(prev => prev.map(item =>
                                                                                visibleItems.find(v => v.id === item.id)
                                                                                    ? { ...item, selected: shouldSelect }
                                                                                    : item
                                                                            ));
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell onClick={() => toggleCategory(categoryName)}>
                                                                    <IconButton size="small">
                                                                        {expandedCategories[categoryName]
                                                                            ? <KeyboardArrowUp fontSize="small" />
                                                                            : <KeyboardArrowDown fontSize="small" />}
                                                                    </IconButton>
                                                                </TableCell>
                                                                <TableCell colSpan={6} onClick={() => toggleCategory(categoryName)}>
                                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                        <Typography sx={{ fontWeight: 700, fontSize: "13px", color: "#c2410c" }}>
                                                                            🍽️ {categoryName}
                                                                        </Typography>
                                                                        <Chip
                                                                            label={`${visibleItems.length} items`}
                                                                            size="small"
                                                                            sx={{ fontSize: "11px", backgroundColor: "#fed7aa", color: "#c2410c", fontWeight: 600 }}
                                                                        />
                                                                        {someSelected && (
                                                                            <Chip
                                                                                label={`${visibleItems.filter(i => i.selected).length} selected`}
                                                                                size="small"
                                                                                color="success"
                                                                                sx={{ fontSize: "11px", fontWeight: 600 }}
                                                                            />
                                                                        )}
                                                                    </Box>
                                                                </TableCell>
                                                            </TableRow>

                                                            {/* ✅ Dish Rows */}
                                                            {expandedCategories[categoryName] && visibleItems.map(item => (
                                                                <TableRow
                                                                    key={item.id}
                                                                    hover
                                                                    sx={{ background: item.selected ? "#f0fdf4" : "#fffbf7" }}
                                                                >
                                                                    <TableCell padding="checkbox">
                                                                        <Checkbox
                                                                            size="small"
                                                                            checked={item.selected}
                                                                            onChange={() => toggleSelectItem(item.id)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell />

                                                                    <TableCell>
                                                                        <Typography sx={{ fontSize: "13px", fontWeight: 500, pl: 1 }}>
                                                                            {item.name}
                                                                        </Typography>
                                                                    </TableCell>
                                                                    <TableCell>₹{item.price}</TableCell>
                                                                    <TableCell>
                                                                        <Select
                                                                            size="small"
                                                                            value={item.discountType}
                                                                            disabled={!item.selected}
                                                                            onChange={e => updateItemDiscount(item.id, "discountType", e.target.value)}
                                                                            sx={{ fontSize: "12px", minWidth: 110 }}
                                                                        >
                                                                            <MenuItem value="percentage">% Off</MenuItem>

                                                                        </Select>
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {item.discountType !== "bogo" ? (
                                                                            <TextField
                                                                                size="small"
                                                                                type="number"
                                                                                value={item.discountValue}
                                                                                disabled={!item.selected}
                                                                                onChange={e => updateItemDiscount(item.id, "discountValue", e.target.value)}
                                                                                sx={{ width: 80 }}
                                                                                placeholder="0"
                                                                            />
                                                                        ) : (
                                                                            <Typography sx={{ fontSize: "12px", color: "#9ca3af" }}>—</Typography>
                                                                        )}
                                                                    </TableCell>
                                                                    <TableCell sx={{ fontWeight: 600, color: item.selected ? "#059669" : "#9ca3af" }}>
                                                                        {item.selected
                                                                            ? item.discountType === "bogo" ? "BOGO" : `₹${discountedPrice(item)}`
                                                                            : `₹${item.price}`}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}

                                                        </React.Fragment>
                                                    );
                                                })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}
                        </Box>
                    )}
                    {/* Footer */}
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
                        <Button
                            variant="contained"
                            size="large"
                            endIcon={<ArrowForwardIcon />}
                            onClick={onNext}
                            disabled={
                                formData.goal === "discount"
                                    ? !formData.goal          // ✅ only needs goal
                                    : !formData.goal || !formData.subGoal  // needs both
                            }
                            sx={{ borderRadius: "10px", px: 4, fontWeight: 600, textTransform: "none" }}
                        >
                            Next
                        </Button>
                    </Box>

                </CardContent>
            </Card>
        </Box >
    );
};

export default GoalDetails;